import type { ReactElement } from 'react';
import { Select } from 'antd';
import { useTranslation } from '@govard/i18n-core/react';
import { TagChip } from '../../../components/entity-detail/TagChip.js';
import { getEnumLabel, matchesTagSearch } from '../../../shared/format/enum-labels.js';

export type ContactListFilter = 'all' | 'with_deals' | 'with_email';

export function ContactListFilters({
  scope,
  tag,
  tags,
  onScopeChange,
  onTagChange,
}: {
  scope: ContactListFilter;
  tag: string | undefined;
  tags: string[];
  onScopeChange: (value: ContactListFilter) => void;
  onTagChange: (value: string | undefined) => void;
}): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      <Select<ContactListFilter>
        data-testid="contacts-scope-filter"
        aria-label={t('crm.features.features.contacts.pages.contactspage.фильтр_контактов')}
        value={scope}
        onChange={onScopeChange}
        style={{ width: 180, fontSize: 12 }}
        options={[
          {
            value: 'all',
            label: t('crm.features.features.contacts.pages.contactspage.все_контакты'),
          },
          {
            value: 'with_deals',
            label: t('crm.features.features.contacts.pages.contactspage.со_сделками'),
          },
          {
            value: 'with_email',
            label: t('crm.features.features.contacts.pages.contactspage.с_email'),
          },
        ]}
      />
      <Select<string>
        data-testid="contacts-tag-filter"
        classNames={{ popup: { root: 'entity-tag-options' } }}
        menuItemSelectedIcon={null}
        aria-label={t('crm.features.features.contacts.pages.contactspage.фильтр_по_тегу')}
        allowClear
        showSearch
        value={tag ?? null}
        onChange={onTagChange}
        placeholder={t('crm.entity_detail.all_tags')}
        style={{ width: 200, fontSize: 12 }}
        options={tags.map((value) => ({ value, label: getEnumLabel('tag', value, t) }))}
        optionRender={(option) => <TagChip value={String(option.value)} />}
        labelRender={({ value }) => <TagChip value={String(value)} />}
        filterOption={(search, option) => matchesTagSearch(String(option?.value ?? ''), search, t)}
      />
    </>
  );
}
